import React from "react";
import DummyError from "../form/DummyError";

const DropzoneError = () => <DummyError name="uploadFiles" />;

export default DropzoneError;
